import { render, staticRenderFns } from "./CalendarioPrenotazioni.vue?vue&type=template&id=028097fd&"
import script from "./CalendarioPrenotazioni.vue?vue&type=script&lang=js&"
export * from "./CalendarioPrenotazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports